// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__bF9sY","colMaxWidth":"Table_colMaxWidth__2NFeu"};